import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { Box, Flex, Text, Toggle } from '@hivewatch/dark'

import { getNotificationsTabTokens } from '../../styles/tokens'

export interface InboxDrawerTitleIProps {
  title: string
  checked?: boolean
  onChange: () => void
}

export const InboxDrawerTitle = ({
  title,
  checked = false,
  onChange,
}: InboxDrawerTitleIProps) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const tokens = getNotificationsTabTokens(colorScheme)
  const showUnreadLabel = t('common:notification_inbox_show_unread')

  return (
    <Flex
      alignItems='center'
      direction='row'
      height='100%'
      justifyContent='center'
      w='full'
    >
      <Box
        alignItems='center'
        color={tokens.textPrimary}
        display='flex'
        flex={1}
        flexDirection='row'
        gap='3'
        textAlign='center'
        w='full'
      >
        <Text display='flex' flex={1} textAlign='center'>
          {title}
        </Text>
        <Text
          color={tokens.textSecondary}
          textStyle='label'
          whiteSpace='nowrap'
        >
          {showUnreadLabel}
        </Text>
        <Toggle
          aria-label={showUnreadLabel}
          colorScheme={colorScheme}
          data-testid='notificationTab_inboxDrawer_filterToggle'
          isOn={checked}
          onChange={onChange}
        />
      </Box>
    </Flex>
  )
}
